import { Box, styled } from '@mui/material';

export const OverviewProjectBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  height: '95vh',
  maxWidth: '92wh',
  overflowY: 'auto',
  borderRadius: '2px',
  flexDirection: 'column',
  padding: theme.spacing(2),
  boxShadow: theme.shadows[2],
  backgroundColor: theme.palette.background.paper,
}));

export const HeaderUnderline = styled(Box)(() => ({
  display: 'flex',
  height: '48px',
  width: '100%',
  borderBottom: '1px solid #F2F2F2',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const SidebarContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
